module.exports = __webpack_public_path__ + "img/bag.795d8fcc.png";